<div>
    <app-content-container [content_template]="page_content" [is_loading]="false" [loading_text]="''"
                           [custom_class]="'no-padding'"></app-content-container>
</div>
<ng-template #page_content>
    <div class="padding" style="max-width: 800px; text-align: left; margin: auto;">
        <markdown class="variable-binding" [data]="markdown"></markdown>
    </div>
</ng-template>
